import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/procedimentoplanooperadora";

/**
 * Classe de gerenciamento de chamadas da API do ProcedimentoPlanoOperadora
 *
 * @class
 */
export default class ProcedimentoPlanoOperadoraApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe ProcedimentoPlanoOperadoraApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
   * @returns registro do Procedimento Plano Operadora
   */
    LerRegistro(codProcedimento: number, codPlanoOperadora: number) {
        return this.api<ApplicationModule[]>(`${controller}/lerRegistro`, {
            method: "GET",
            params: { codProcedimento, codPlanoOperadora }
        });
    }

}